import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleYahooCallback } from '../services/api';

/**
 * Handles the Yahoo OAuth callback redirect.
 * Extracts `code` from the URL, calls the backend to exchange it for tokens,
 * then navigates back to the league creation page.
 */
function YahooCallbackView() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const code = searchParams.get('code');
    const returnTo = sessionStorage.getItem('yahooReturnTo') || '/league/new';
    sessionStorage.removeItem('yahooReturnTo');

    if (!code) {
      navigate(returnTo + '?yahoo=error');
      return;
    }

    handleYahooCallback(code)
      .then(() => navigate(returnTo + '?yahoo=connected'))
      .catch(() => navigate(returnTo + '?yahoo=error'));
  }, [searchParams, navigate]);

  return (
    <div className='loading'>
      <div className='spinner' />
      <p>Connecting Yahoo account...</p>
    </div>
  );
}

export default YahooCallbackView;
